<template>
  <div>
    <v-card class="px-3 py-2 ma-0" elevation="0">
      <v-row ma-0>
        <v-col cols="6" class="pb-0 pr-0">
          <v-text-field
            ma-0
            pa-0
            outlined
            :placeholder="$t('viewSuppliersSearch.Start_typing_the_part_code')"
            append-icon="fa-search"
            @click:append="brandsGet"
            hide-details
            v-model="brands.part_number"
            @keyup="autosearch ? brandsGet() : ''"
            @keyup.enter="brandsGet"
            :loading="brands.loader"
          ></v-text-field>
        </v-col>
        <v-col cols="6" class="pb-0 pr-3 mx-0">
          <v-select
            hide-details
            class="pa-0 ma-0"
            outlined
            :items="pricesTypes"
            :label="$t('viewSettings.prices_types.caption')"
            item-text="name"
            return-object
            v-model="currentPriceType"
          >
          </v-select>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="px-3 py-2 ma-0 mt-8" elevation="0">
      <v-row ma-0>
        <v-col cols="6" class="pb-0 pr-0">
          <v-text-field
            ma-0
            outlined
            :placeholder="$t('common.brand')"
            hide-details
            v-model="partForSearch.brand"
            @keyup.enter="
              partsGet(partForSearch.brand, partForSearch.part_code)
            "
            :loading="parts.loader"
          ></v-text-field>
        </v-col>
        <span id="partsSearchResult"></span>
        <v-col cols="6">
          <v-text-field
            ma-0
            outlined
            :placeholder="$t('common.part_code')"
            append-icon="fa-search"
            hide-details
            @click:append="
              partsGet(partForSearch.brand, partForSearch.part_code)
            "
            v-model="partForSearch.part_code"
            @keyup.enter="
              partsGet(partForSearch.brand, partForSearch.part_code)
            "
            :loading="parts.loader"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- таблица с брендами-->
      <v-data-table
        v-if="!brands.loader && parts.stats === null"
        id="tableSuppliers"
        :headers="tableBrandsHeader"
        :items="brandsFiltered"
        class="elevation-0"
        :height="
          brandsFiltered.length > 0 ? tableSuppliersHeight - 417 + 'px' : 'auto'
        "
        dense
        :footer-props="table.options"
        :hide-default-footer="true"
        :items-per-page="10000"
        :class="{ 'mb-0': $vuetify.breakpoint.mdAndUp }"
      >
        <template v-slot:item="props">
          <tr>
            <td
              class="text-xs-left pointer"
              @click="partsGet(props.item.brand, props.item.part_code)"
            >
              {{ props.item.brand }} {{ props.item.part_code }}
            </td>
            <td
              class="text-xs-left pointer"
              @click="partsGet(props.item.brand, props.item.part_code)"
            >
              {{ props.item.name }}
            </td>
            <td
              class="text-xs-left pointer"
              @click="partsGet(props.item.brand, props.item.part_code)"
            >
              <template v-if="props.item.picture_preview">
                <img style="height: 30px" :src="props.item.picture_preview" />
              </template>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_data_available") }}
        </template>
        <template v-slot:no-results>
          {{ $t("common.no_data_available") }}
        </template>
        <template slot="pageText" slot-scope="item">
          {{ item.pageStart }} - {{ item.pageStop }}
          {{ $t("viewAMSearch.pagination_of") }}
          {{ item.itemsLength }}
        </template>
        <template v-slot:no-data>
          {{ $t("common.no_data_available") }}
        </template>
        <template v-slot:no-results>
          {{ $t("common.no_data_available") }}
        </template>
      </v-data-table>
      <v-tabs center-active show-arrows v-model="supplierPartTab">
        <v-tab v-for="(partsData, name) in partsDataFiltered" :key="name">
          {{ $t("viewSearch.partsCategoriesNames." + name) }} ({{
            partsDataFiltered[name].length
          }})
        </v-tab>
        <v-spacer></v-spacer>
        <v-menu v-if="parts.stats">
          <template v-slot:activator="{ on }">
            <div>
              <v-btn
                small
                text
                fab
                class="align-self-center mr-0"
                @click="isVisibleDialogStat = true"
                :title="$t('common.statistics')"
              >
                <v-icon small>fa-info-circle</v-icon>
              </v-btn>
              <v-btn
                v-if="partForSearch.part_code"
                small
                text
                fab
                inlist=""
                :title="$t('applicabilityWindow.applicability')"
                @click="
                  applicabilityWin.partNumber = partForSearch.part_code;
                  applicabilityWin.isVisible = true;
                "
              >
                <v-icon small>$applicability</v-icon>
              </v-btn>
            </div>
          </template>
        </v-menu>
        <applicability-window
          :part-number="applicabilityWin.partNumber"
          :show="applicabilityWin.isVisible"
          @hide="applicabilityWin.isVisible = false"
        ></applicability-window>
      </v-tabs>
      <v-tabs-items v-model="supplierPartTab">
        <v-tab-item v-for="(partsData, name) in partsDataFiltered" :key="name">
          <!-- таблица с запчастями(предложениями)-->
          <v-data-table
            id="tableSuppliers"
            v-show="
              !parts.loader && partsData.length && !categoriesHidden[name]
            "
            :headers="tablePartsHeader"
            :items="partsData"
            dense
            class="elevation-0 mb-2"
            :height="tableSuppliersHeight - 417 + 'px'"
            :footer-props="table.options"
            :hide-default-footer="true"
            :items-per-page="10000"
            :class="{ 'mb-0': $vuetify.breakpoint.mdAndUp }"
          >
            <template v-slot:item="props">
              <tr>
                <td class="text-xs-left">
                  {{ supplierNameForHuman(props.item) }}
                </td>
                <td
                  class="text-xs-left pointer"
                  @click="partsGet(props.item.brand, props.item.part_code)"
                >
                  <span class="dashed"
                    >{{ props.item.brand }} {{ props.item.part_code }}</span
                  >
                </td>

                <td class="text-xs-left text-no-wrap">
                  <strong class="d-inline-block">{{
                      formatCurrency(priceWithDiscount(
                      props.item.price,
                      props.item.price_with_margin
                    ))
                  }}</strong>
                </td>
                <td class="text-right text-no-wrap">
                  <strong class="pr-2">{{ props.item.delivery_time }}</strong>
                  <v-progress-circular
                    v-if="props.item.delivery_chance"
                    :rotate="360"
                    :size="15"
                    :width="7.5"
                    :value="props.item.delivery_chance"
                    :color="chanceColor(props.item.delivery_chance)"
                    :title="
                      $t('viewSuppliersSearch.delivery_chance') +
                      ': ' +
                      props.item.delivery_chance +
                      '%'
                    "
                  >
                  </v-progress-circular>
                  <v-btn
                    text
                    fab
                    x-small
                    rounded
                    @click="showFullInfoPartSuppliersDialog(props.item)"
                  >
                    <v-icon small>fa-info-circle</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left">
                  <span
                    >{{ props.item.stock_location }}
                    {{ props.item.stock }}</span
                  >
                </td>

                <td class="text-xs-left pointer">
                  <v-btn
                    color="success"
                    class="ml-5 green-shadow"
                    x-small
                    elevation="0"
                    :loading="savingInProgress || cartIsLoading"
                    fab
                    :disabled="savingInProgress || cartIsLoading"
                    max-width="26"
                    max-height="26"
                    @click="tryAddPartToCart(props.item)"
                    id="addToOrder"
                  >
                    <v-icon x-small>fa-plus</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
      <p v-if="Object.keys(partsDataFiltered).length===0 && parts.stats" class="text-center text-disabled font-weight-thin">
        {{$t('common.no_data_available')}}
      </p>
    </v-card>
    <v-dialog v-model="fullInfoDialog.isVisible" scrollable max-width="600px">
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">{{ $t("Info") }}</h3>
          <v-spacer></v-spacer>

          <v-btn
            icon
            @click="
              fullInfoDialog.isVisible = false;
              itemFullInfoForDialog = [];
            "
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="ma-0 pa-0">
          <div class="pa-3">
            <div
              class="text-xs-center"
              v-if="partFullInfoProcessedItems.picture"
            >
              <img
                style="max-width: 80%; display: block; margin: 0 auto"
                :src="partFullInfoProcessedItems.picture"
              />
            </div>
            <template v-for="(value, key) in partFullInfoProcessedItems">
              <template v-if="key !== 'picture' && key !== 'picture_preview' && key !== 'price'">
                <div class="pb-3">
                  <strong>{{ key }}</strong
                  >: {{ value }}
                </div>
              </template>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isVisibleDialogStat" scrollable max-width="600px">
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">{{ $t("common.statistics") }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="isVisibleDialogStat = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="ma-0 pa-0">
          <div class="pa-3">
            <template v-if="parts.stats && parts.stats.total">
              <h3>{{ $t("viewSuppliersSearch.stat.total") }}</h3>
              <p class="mb-0 pb-0" v-for="(val, key) in parts.stats.total">
                <strong>{{ $t("viewSuppliersSearch.stat." + key) }}:</strong>
                {{ val }}
              </p>
            </template>
            <template v-if="parts.stats && parts.stats.suppliers">
              <template v-for="(data, supplierName) in parts.stats.suppliers">

                <h3 class="mt-2">{{ supplierNameForHuman(supplierName) }}</h3>

                <template class="mb-0 pb-0" v-for="(val, key) in data">
                  <p v-if="! hiddenStatKeys.includes(key)" class="mb-0 pb-0">
                    <strong>{{ $t("viewSuppliersSearch.stat." + key) }}:</strong>
                    {{ val }}
                  </p>
                </template>

              </template>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      v-model="isVisibleDialogRepairtimeSelect"
      scrollable
      max-width="650px"
    >
      <v-card>
        <v-card-title>{{
          $t("viewSearch.select_repairtime_for_attach")
        }}</v-card-title>
        <v-card-text>
          <v-select
            xs6
            item-text="name"
            item-value="id"
            :items="repairtimesFromCurrentCart"
            :label="$t('viewSearch.repairtimes')"
            v-model="tmpRepairtimeId"
          >
          </v-select>
          <v-row justify="start">
            <v-spacer></v-spacer>
            <v-btn
              :loading="savingInProgress"
              class="mr-2 mt-4"
              color="red"
              @click="
                tmpPartForAddToCart = null;
                tmpRepairtimeId = null;
                isVisibleDialogRepairtimeSelect = false;
              "
            >
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
              :loading="savingInProgress"
              class="mr-2 mt-4"
              color="orange"
              @click="
                addPartToCart(tmpPartForAddToCart);
                isVisibleDialogRepairtimeSelect = false;
              "
            >
              {{ $t("viewSearch.add_without_attach") }}
            </v-btn>
            <v-btn
              :disabled="!tmpRepairtimeId"
              :loading="savingInProgress"
              class="mr-2 mt-4"
              color="green"
              @click="
                tmpPartForAddToCart.repairtime_id_in_cart = tmpRepairtimeId;
                addPartToCart(tmpPartForAddToCart);
                isVisibleDialogRepairtimeSelect = false;
              "
            >
              {{ $t("viewSearch.add_to_selected") }}
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <choose-remains-form
      :nomenclature="chooseRemainsForm.nomenclature"
      :show="chooseRemainsForm.isVisible"
      @choose="(items) => tryAddToCartFromRemains(items)"
      @hide="chooseRemainsForm.isVisible = false"
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import ApplicabilityWindow from "@/components/common/ApplicabilityWindow";
import CommonMixin from "@/mixins/common";
import ChooseRemainsForm from "@/components/storage/ChooseRemainsForm";

export default {
  name: "SearchSuppliers",
  components: { ChooseRemainsForm, ApplicabilityWindow },
  props: {
    dataForSearch: Object,
  },
  mixins: [CommonMixin],
  data: () => ({
    hiddenStatKeys:[
        'platform_supplier', 'platform_supplier_id'
    ],
    tmpRepairtimeId: null,
    tmpPartForAddToCart: null,
    isVisibleDialogRepairtimeSelect: false,
    chooseRemainsForm: {
      isVisible: false,
      nomenclature: null,
    },
    categoriesHidden: {
      pricelists: false,
      requested_parts: false,
      replica: false,
      parts_component: false,
      related_parts: false,
    },
    isVisibleDialogStat: false,
    autosearch: false,
    tableSuppliersHeight: null,
    supplierPartTab: 0,
    tableSuppliers: {
      show: false,
      img: "",
      showTitle: false,
      title: "",
      subTitle: "",
      header: [],
      itemsForProcessing: [],
      rowsPerPageItems: [10, 25, 50],
    },
    fullInfoDialog: {
      isVisible: false,
      partFullInfo: null,
    },
    response_debug_show: false,
    table: {
      options: {
        "items-per-page": [10000, 15000, 20000],
        "next-icon": "navigate_next",
        "prev-icon": "navigate_before",
      },
    },
    /**
     * Used to set parameters of ApplicabilityWindow.
     */
    applicabilityWin: {
      partNumber: null,
      isVisible: false,
    },
  }),
  mounted() {
    this.$store.dispatch("suppliers/getSuppliersListByAPI");
    this.$store.dispatch("prices_types/get");
    if (
      this.$route.params &&
      this.$route.params.brand &&
      this.$route.params.search_number
    ) {
      this.dataForSearch.brand = this.$route.params.brand;
      this.dataForSearch.part_code = this.$route.params.search_number;
      this.tableSuppliers.show = false;
      this.$store.dispatch("suppliers/partsGet", this.dataForSearch);
    }
    this.$nextTick(function () {
      this.getTableSuppliersHeight();
    });
    if (
      this.repairtimesFromCurrentCart[0] &&
      this.repairtimesFromCurrentCart[0].id
    )
      this.tmpRepairtimeId = this.repairtimesFromCurrentCart[0].id;
  },
  computed: {
    ...mapFields("cart", ["carts", "defaultCartId", "savingInProgress", "cartIsLoading"]),
    ...mapFields("prices_types", ["pricesTypes", "currentPriceType"]),
    ...mapFields("suppliers", ["time", "brands", "parts", "suppliersNames"]),
    partForSearch: {
      get() {
        return this.dataForSearch;
      },
      set(value) {
        this.$emit("update:data-for-search", value);
      },
    },
    hasRepairtimesInCart() {
      return this.carts.some((cart) => {
        return (
          cart.items.filter((item) => item.type == "repairtime").length > 0 &&
          cart.is_default == 1
        );
      });
    },
    repairtimesFromCurrentCart() {
      if (!this.carts) return [];
      let res = this.carts.filter((cart) => {
        return (
          cart.items.filter((item) => item.type == "repairtime").length > 0 &&
          cart.is_default == 1
        );
      });
      if (res[0])
        return res[0].items.filter((item) => item.type == "repairtime");
      return [];
    },
    brandsFiltered() {
      let tmp = {};
      let res = [];
      for (let i in this.brands.parts) {
        if (
          !tmp[
            (
              this.brands.parts[i].brand +
              "_" +
              this.brands.parts[i].part_code
            ).toLocaleUpperCase()
          ]
        ) {
          res.push(this.brands.parts[i]);
          tmp[
            (
              this.brands.parts[i].brand +
              "_" +
              this.brands.parts[i].part_code
            ).toLocaleUpperCase()
          ] = true;
        }
      }
      return res;
    },
    partsDataFiltered() {
      let res = {};
      for (let i in this.parts.data) {
        if (this.parts.data[i].length) {
          res[i] = this.parts.data[i];
        }
      }
      return res;
    },
    partFullInfoProcessedItems() {
      let data = {};
      for (let key in this.fullInfoDialog.partFullInfo) {
        if (this.fullInfoDialog.partFullInfo[key] !== "") {

          switch (key) {
            case "price":
            case "price_with_margin":
              data[this.$t("viewSuppliersSearch." + key)] =
                  this.formatCurrency(this.fullInfoDialog.partFullInfo[key]);
              break;
            case "picture":
              data[key] = this.fullInfoDialog.partFullInfo[key];
              break;
            case "picture_preview":
              data[key] = this.fullInfoDialog.partFullInfo[key];
              break;
            case "source":
              data[this.$t("viewSuppliersSearch." + key)] = this.$t(
                "viewSuppliersSearch." + this.fullInfoDialog.partFullInfo[key]
              );
              break;
            case "supplier":
              data[this.$t("viewSuppliersSearch." + key)] =
                this.supplierNameForHuman(this.fullInfoDialog.partFullInfo);
              break;
            default:
              if(this.$te("viewSuppliersSearch." + key)) { //проверим что есть перевод
                data[this.$t("viewSuppliersSearch." + key)] =
                    this.fullInfoDialog.partFullInfo[key] ;
              }
              break;
          }
        }
      }
      return data;
    },

    tablePartsHeader() {
      return [
        {
          text: this.$t("common.supplier"),
          value: "supplier",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.brand") + "/" + this.$t("common.part_code"),
          value: "brand",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewSuppliersSearch.Delivery"),
          value: "delivery_time",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewSuppliersSearch.stock"),
          value: "stock",
          sortable: true,
          class: "text-no-wrap",
        },
        { text: "", sortable: false },
      ];
    },
    tableBrandsHeader() {
      return [
        {
          text: this.$t("common.brand") + "/" + this.$t("common.part_code"),
          value: "brand_name",
          sortable: true,
        },
        {
          text: this.$t("common.description"),
          value: "part_name",
          sortable: true,
        },
        {
          text: this.$t("common.picture"),
          value: "images_small",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    getTableSuppliersHeight() {
      if (!document.getElementById("tableSuppliers")) {
        this.tableSuppliersHeight = null;
        return;
      }
      this.tableSuppliersHeight =
        window.innerHeight - document.getElementById("tableSuppliers").offsetTop - 96;
    },
    brandsGet() {
      this.$store.dispatch("suppliers/brandsGet", { with_goods: true });
    },
    partsGet(brand, part_code) {
      this.partForSearch.brand = brand;
      this.partForSearch.part_code = part_code;
      this.tableSuppliers.show = false;
      this.$store
        .dispatch("suppliers/partsGet", this.partForSearch)
        .then(() => {
          this.getTableSuppliersHeight();
          this.supplierPartTab = 0;
        });
    },
    priceWithDiscount(price, price_with_margin) {
      let res;
      if (
        parseInt(this.currentPriceType.for_suppliers_price_with_margin) === 1
      ) {
        res = parseFloat(
          (price_with_margin * (100 - this.currentPriceType.coefficient)) / 100
        ).toFixed(2);
      } else {
        res = parseFloat(
          price +
            ((price_with_margin - price) *
              (100 - this.currentPriceType.coefficient)) /
              100
        ).toFixed(2);
      }
      return res;
    },
    tryAddToCartFromRemains(items) {
      items.forEach((item) => {
        item.delivery_time = 0;
        item.name = item.part_name;
        this.tryAddPartToCart(item, true);
      });
    },
    tryAddPartToCart(item, disabledChooseFromRemainsForm = false) {
      // console.log('tryAddPartToCart')
      // console.log('item=', item)
      // if(disabledChooseFromRemainsForm === false
      //     && item.platform_supplier
      //     && item.platform_supplier.type==='storage'
      //     && this.isEnabledStorageV2){
      //   //выбор товара из складских остатков
      //   this.showChooseFromRemainsForm(item);
      //   return;
      // }
      let crossed_from_brand = this.partForSearch.brand || "";
      let crossed_from_part_number = this.partForSearch.part_code || "";
      crossed_from_part_number = crossed_from_part_number.replace(/\s/g, "");

      let data = {
        type: "part",
        brand: item.brand,
        part_number: item.part_code,
        name: item.name,
        price: this.priceWithDiscount(item.price, item.price_with_margin),
        purchase_price: item.price,
        supplier_name: this.supplierNameForHuman(item),
        delivery_time: item.delivery_time,
        crossed_from_brand: crossed_from_brand,
        crossed_from_part_number: crossed_from_part_number,
        goods_id: item.goods_id,
        supplier_id: item.platform_supplier && item.platform_supplier.id,
        supplier_type: item.platform_supplier && item.platform_supplier.type,
        storage_id: item.storage_id,
        storage_rack_id: item.storage_rack_id,
        storage_rack_shelve_id: item.storage_rack_shelve_id,
        nomenclature_id: item.nomenclature_id,
      };
      if (!this.hasRepairtimesInCart) {
        this.addPartToCart(data);
      } else {
        this.isVisibleDialogRepairtimeSelect = true;
        this.tmpPartForAddToCart = data;
      }
    },
    showFullInfoPartSuppliersDialog(data) {
      this.fullInfoDialog.partFullInfo = data;
      this.fullInfoDialog.isVisible = true;
    },
    chanceColor(item) {
      let color = "red";
      if (item >= 50) color = "yellow";
      if (item >= 75) color = "green";
      return color;
    },
    supplierNameForHuman(supplier) {
      if (typeof supplier === "string") {
        return supplier;
      }
      if (supplier && supplier.platform_supplier) {
        return supplier.platform_supplier.name;
      }
    },
    showChooseFromRemainsForm(nomenclature) {
      this.chooseRemainsForm.isVisible = true;
      this.chooseRemainsForm.nomenclature = nomenclature;
    },
  },
  watch: {
    "parts.loader"() {
      this.$nextTick(function () {
        this.getTableSuppliersHeight();
      });
    },
    "brands.loader"() {
      this.$nextTick(function () {
        this.getTableSuppliersHeight();
      });
    },
    $route(to, fr) {
      if (this.$route.params.brand && this.$route.params.search_number) {
        this.partsGet(
          this.$route.params.brand,
          this.$route.params.search_number
        );
      }
    },
    repairtimesFromCurrentCart(to, fr) {
      this.tmpRepairtimeId = null;
    },
  },
};
</script>

<style scoped></style>
